<div class="live-class-container">
  @if (isLoading()) {
    <div class="loading-screen">
      <div class="spinner-large"></div>
      <p class="loading-text">Cargando evento...</p>
    </div>
  } @else if (evento()) {
    <!-- Layout con Video y Chat lado a lado -->
    <div class="live-content">
      <!-- Video -->
      <div class="video-section">
        <div class="video-wrapper">
          @if (isEnVivo()) {
            <div class="live-badge">
              <span class="live-dot"></span>
              EN VIVO
            </div>
          }
          
          @if (safeVideoIframe) {
            <div class="video-player" [innerHTML]="safeVideoIframe"></div>
          } @else {
            <div class="video-placeholder">
              <svg width="64" height="64" viewBox="0 0 64 64" fill="none">
                <circle cx="32" cy="32" r="30" stroke="rgba(255,255,255,0.2)" stroke-width="2"/>
                <path d="M24 20L44 32L24 44V20Z" fill="rgba(255,255,255,0.3)"/>
              </svg>
              <p>Cargando transmisión...</p>
            </div>
          }
        </div>
        
        <div class="event-info">
          <button class="back-btn" (click)="goBack()">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <path d="M19 12H5M5 12L12 19M5 12L12 5" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            </svg>
            Volver
          </button>

          <h1 class="event-title">{{ evento()!.titulo }}</h1>
          
          <div class="event-details">
            <div class="instructor-info">
              <div class="instructor-avatar-wrapper">
                <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
                  <circle cx="20" cy="20" r="20" fill="#0e40d8"/>
                  <circle cx="20" cy="16" r="6" fill="white"/>
                  <path d="M10 32C10 26.4772 14.4772 22 20 22C25.5228 22 30 26.4772 30 32" stroke="white" stroke-width="2"/>
                </svg>
              </div>
              <div class="instructor-text">
                <div class="instructor-label">Instructor</div>
                <div class="instructor-name">{{ evento()!.instructor }}</div>
              </div>
            </div>

            <div class="event-stats">
              <div class="stat">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
                  <path d="M12 6V12L16 14" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                </svg>
                <span>{{ getDuracion() }}</span>
              </div>

              <div class="stat">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M17 21V19C17 17.9391 16.5786 16.9217 15.8284 16.1716C15.0783 15.4214 14.0609 15 13 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21" stroke="currentColor" stroke-width="2"/>
                  <circle cx="9" cy="7" r="4" stroke="currentColor" stroke-width="2"/>
                </svg>
                <span>{{ evento()!.inscritos }} / {{ evento()!.capacidad_maxima }} participantes</span>
              </div>

              <div class="stat category">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M2 3H8C9.06087 3 10.0783 3.42143 10.8284 4.17157C11.5786 4.92172 12 5.93913 12 7V21C12 20.2044 11.6839 19.4413 11.1213 18.8787C10.5587 18.3161 9.79565 18 9 18H2V3Z" stroke="currentColor" stroke-width="2"/>
                  <path d="M22 3H16C14.9391 3 13.9217 3.42143 13.1716 4.17157C12.4214 4.92172 12 5.93913 12 7V21C12 20.2044 12.3161 19.4413 12.8787 18.8787C13.4413 18.3161 14.2044 18 15 18H22V3Z" stroke="currentColor" stroke-width="2"/>
                </svg>
                <span>{{ evento()!.estado }}</span>
              </div>
            </div>
          </div>

          <p class="event-description">{{ evento()!.descripcion }}</p>
          
          @if (!inscrito()) {
            <button class="btn-inscribirse" (click)="inscribirse()">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M10 5V15M5 10H15" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
              </svg>
              Inscribirse al Evento
            </button>
          }
        </div>
      </div>

      <!-- Chat -->
      <div class="chat-section">
        <div class="chat-wrapper">
          <h3 class="chat-title">Chat en vivo</h3>
          @if (safeChatIframe) {
            <div class="chat-iframe" [innerHTML]="safeChatIframe"></div>
          } @else {
            <div class="chat-placeholder">
              <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
                <rect x="8" y="12" width="32" height="28" rx="4" stroke="rgba(255,255,255,0.2)" stroke-width="2"/>
                <path d="M16 20H32M16 26H24" stroke="rgba(255,255,255,0.3)" stroke-width="2" stroke-linecap="round"/>
              </svg>
              <p>Cargando chat...</p>
            </div>
          }
        </div>
      </div>
    </div>
  }

  <!-- Contenido antiguo de tabs (opcional, puedes eliminarlo) -->
  <div style="display: none;">

  <!-- Sidebar -->
  <aside class="sidebar">
    <!-- Tab Navigation -->
    <div class="tab-nav">
      <button 
        class="tab-button"
        [class.active]="currentTab() === 'chat'"
        (click)="setTab('chat')">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
          <path d="M21 15C21 15.5304 20.7893 16.0391 20.4142 16.4142C20.0391 16.7893 19.5304 17 19 17H7L3 21V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H19C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V15Z" stroke="currentColor" stroke-width="2"/>
        </svg>
        Chat
      </button>

      <button 
        class="tab-button"
        [class.active]="currentTab() === 'participants'"
        (click)="setTab('participants')">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
          <path d="M17 21V19C17 17.9391 16.5786 16.9217 15.8284 16.1716C15.0783 15.4214 14.0609 15 13 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21" stroke="currentColor" stroke-width="2"/>
          <circle cx="9" cy="7" r="4" stroke="currentColor" stroke-width="2"/>
          <path d="M23 21V19C22.9993 18.1137 22.7044 17.2528 22.1614 16.5523C21.6184 15.8519 20.8581 15.3516 20 15.13" stroke="currentColor" stroke-width="2"/>
          <path d="M16 3.13C16.8604 3.35031 17.623 3.85071 18.1676 4.55232C18.7122 5.25392 19.0078 6.11683 19.0078 7.005C19.0078 7.89318 18.7122 8.75608 18.1676 9.45769C17.623 10.1593 16.8604 10.6597 16 10.88" stroke="currentColor" stroke-width="2"/>
        </svg>
        Participantes
      </button>

      <button 
        class="tab-button"
        [class.active]="currentTab() === 'qa'"
        (click)="setTab('qa')">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
          <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
          <path d="M9.09 9C9.3251 8.33167 9.78915 7.76811 10.4 7.40913C11.0108 7.05016 11.7289 6.91894 12.4272 7.03871C13.1255 7.15849 13.7588 7.52152 14.2151 8.06353C14.6713 8.60553 14.9211 9.29152 14.92 10C14.92 12 11.92 13 11.92 13" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          <circle cx="12" cy="17" r="0.5" fill="currentColor" stroke="currentColor"/>
        </svg>
        Q&A
      </button>
    </div>

    <!-- Tab Content -->
    <div class="tab-content">
      <!-- Chat Tab -->
      <div class="chat-section" *ngIf="currentTab() === 'chat'">
        <div class="chat-messages">
          <div 
            *ngFor="let message of chatMessages"
            class="chat-message"
            [class.instructor]="message.isInstructor">
            <img [src]="message.avatar" [alt]="message.user" class="message-avatar">
            <div class="message-content">
              <div class="message-header">
                <span class="message-user">{{message.user}}</span>
                <span class="instructor-badge" *ngIf="message.isInstructor">Instructor</span>
                <span class="message-time">{{message.time}}</span>
              </div>
              <p class="message-text">{{message.message}}</p>
            </div>
          </div>
        </div>

        <div class="chat-input">
          <input 
            type="text" 
            placeholder="Escribe un mensaje..."
            [value]="newMessage()"
            (input)="newMessage.set($any($event.target).value)"
            (keyup.enter)="sendMessage()">
          <button class="send-btn" (click)="sendMessage()" [disabled]="!newMessage().trim()">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <path d="M22 2L11 13" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
              <path d="M22 2L15 22L11 13L2 9L22 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
        </div>
      </div>

      <!-- Participants Tab -->
      <div class="participants-section" *ngIf="currentTab() === 'participants'">
        <div class="participants-list">
          <div 
            *ngFor="let participant of participants"
            class="participant-item"
            [class.instructor]="participant.role === 'instructor'">
            <img [src]="participant.avatar" [alt]="participant.name" class="participant-avatar">
            <div class="participant-info">
              <div class="participant-name">{{participant.name}}</div>
              <div class="participant-role" *ngIf="participant.role === 'instructor'">Instructor</div>
            </div>
          </div>
        </div>
      </div>

      <!-- Q&A Tab -->
      <div class="qa-section" *ngIf="currentTab() === 'qa'">
        <div class="qa-placeholder">
          <svg width="64" height="64" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
            <path d="M9.09 9C9.3251 8.33167 9.78915 7.76811 10.4 7.40913C11.0108 7.05016 11.7289 6.91894 12.4272 7.03871C13.1255 7.15849 13.7588 7.52152 14.2151 8.06353C14.6713 8.60553 14.9211 9.29152 14.92 10C14.92 12 11.92 13 11.92 13" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            <circle cx="12" cy="17" r="0.5" fill="currentColor" stroke="currentColor"/>
          </svg>
          <h3>Preguntas y Respuestas</h3>
          <p>Haz tus preguntas al instructor durante la clase en vivo</p>
          <button class="qa-btn">
            Hacer una Pregunta
          </button>
        </div>
      </div>
    </div>
  </aside>
</div>

